<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-4">
        <h5 class="modal-title">Add User</h5>
      </div>
      <div class="col-sm-8 btn-holder text-right">
        <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
          <span class="fal fa-times"></span>
          Cancel
        </button>
        <button (click)="save(form)" type="button" class="btn btn-success text-uppercase">
          <span class="fal fa-save"></span>
          Save
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fal fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" class="clearfix">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <h6 class="section-title">User Information</h6>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input
                    type="text"
                    formControlName="firstName"
                    matInput
                    required
                    placeholder="First Name"
                    autocomplete="off"
                  />
                  <mat-error *ngIf="form.get('firstName').touched && form.get('firstName').hasError('required')">
                    First Name is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('firstName').touched && form.get('firstName').hasError('allNumbers')">
                    First Name cannot be numbers alone.
                  </mat-error>
                  <mat-error *ngIf="form.get('firstName').touched && form.get('firstName').hasError('minlength')">
                    First Name must be at least <strong>2</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('firstName').touched && form.get('firstName').hasError('maxlength')">
                    First Name must be at most <strong>50</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('firstName').hasError('name')">
                    Only alphanumeric value is allowed.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input
                    type="text"
                    formControlName="lastName"
                    matInput
                    required
                    placeholder="Last Name"
                    autocomplete="off"
                  />
                  <mat-error *ngIf="form.get('lastName').touched && form.get('lastName').hasError('required')">
                    Last Name is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('lastName').hasError('allNumbers')">
                    Last Name cannot be numbers alone.
                  </mat-error>
                  <mat-error *ngIf="form.get('lastName').hasError('minlength')">
                    Last Name must be at least <strong>2</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('lastName').hasError('maxlength')">
                    Last Name must be at most <strong>50</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('lastName').hasError('name')">
                    Only alphanumeric value is allowed.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input
                    type="email"
                    formControlName="email"
                    matInput
                    required
                    placeholder="Email"
                    autocomplete="off"
                  />
                  <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')">
                    Email is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('email')">
                    Email must have valid format
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <app-national-phone-input2 [ctrl]="form.get('phone')"></app-national-phone-input2>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <mat-select formControlName="role" placeholder="User Role" [required]="true">
                    <mat-option
                      *ngFor="let role of roles$ | async"
                      [value]="role.value"
                      [disabled]="isYearlyOC && role.value == roles.owner.value"
                      [matTooltip]="role.tooltip"
                      matTooltipPosition="right"
                      matTooltipClass="text-center"
                      >{{ role.label }}</mat-option
                    >
                  </mat-select>
                  <mat-error *ngIf="form.get('role').touched && form.get('role').hasError('required')">
                    User Role is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12" formGroupName="attributes">
                <mat-form-field class="mat-block">
                  <mat-select formControlName="gender" placeholder="Gender">
                    <mat-option *ngFor="let gender of genders" [value]="gender.id">{{ gender.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <app-select-search
                  [items]="languages"
                  [ctrl]="form.get('attributes').get('language')"
                  [multiple]="false"
                  bindValue="id"
                  bindLabel="name"
                  placeholder="Language"
                ></app-select-search>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <h6 class="section-title">User Location</h6>
              </div>
              <div class="col-md-12">
                <mat-form-field *ngIf="isGoogleLoaded" class="mat-block">
                  <input
                    appGooglePlaces
                    (onAddressChange)="onPlaceChange($event)"
                    type="text"
                    formControlName="address"
                    matInput
                    placeholder="Address"
                  />
                  <mat-error *ngIf="form.get('address').touched && form.get('address').hasError('minlength')">
                    Address must be at least <strong>2</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('address').touched && form.get('address').hasError('maxlength')">
                    Address must be at most <strong>140</strong> characters long
                  </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="!isGoogleLoaded" class="mat-block">
                  <input type="text" formControlName="address" matInput placeholder="Address" />
                  <mat-error *ngIf="form.get('address').touched && form.get('address').hasError('minlength')">
                    Address must be at least <strong>2</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('address').touched && form.get('address').hasError('maxlength')">
                    Address must be at most <strong>140</strong> characters long
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input type="text" formControlName="city" matInput placeholder="City" />
                  <mat-error *ngIf="form.get('city').touched && form.get('city').hasError('minlength')">
                    City must be at least <strong>2</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('city').touched && form.get('city').hasError('maxlength')">
                    City must be at most <strong>50</strong> characters long
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input type="text" formControlName="state" matInput placeholder="State / Province / Region" />
                  <mat-error *ngIf="form.get('state').touched && form.get('state').hasError('minlength')">
                    Value must be at least <strong>2</strong> characters long
                  </mat-error>
                  <mat-error *ngIf="form.get('state').touched && form.get('state').hasError('maxlength')">
                    Value must be at most <strong>50</strong> characters long
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <app-select-search
                  [items]="countryList"
                  [ctrl]="form.get('country')"
                  [multiple]="false"
                  bindValue="id"
                  bindLabel="name"
                  placeholder="Country"
                ></app-select-search>
              </div>

              <div class="col-md-12">
                <h6 class="section-title">User Credentials</h6>
              </div>

              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input
                    matTooltip="The password is created by the administrator when creating a user profile.  The user will be able to change their password once they log in."
                    matTooltipPosition="above"
                    matTooltipClass="text-center"
                    type="password"
                    formControlName="password1"
                    matInput
                    required
                    placeholder="Password: (Minimum length of 8 characters)"
                    autocomplete="off"
                  />
                  <mat-error *ngIf="form.get('password1').touched && form.get('password1').hasError('required')">
                    Password is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('password1').touched && form.get('password1').hasError('minlength')">
                    Password must be at least <strong>8</strong> characters long
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-12">
                <mat-form-field class="mat-block">
                  <input
                    type="password"
                    formControlName="password2"
                    matInput
                    required
                    placeholder="Repeat Password"
                    autocomplete="off"
                  />
                  <mat-error *ngIf="form.get('password2').touched && form.get('password2').hasError('required')">
                    Password is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('password2').touched && form.get('password2').hasError('minlength')">
                    Password must be at least <strong>8</strong> characters long
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
